<template>
  <div>
    <v-container grid-list-xl fluid ma-3 text-xs-center v-if="collectConsent">
      <v-layout justify-center wrap row>
        <v-flex xs10 headline ma-3>
          Redeeming code for the following:
        </v-flex>
        <v-flex xs8 elevation-2 white pa-5 style="max-width:550px">
          <v-alert
            :value="redeemError"
            type="error"
            outline
          >
            {{ redeemError }}
          </v-alert>
          <v-layout row wrap mb-3>
            <v-flex xs12 sm4>
              <img :src="consentIcon" width="128" height="128">
            </v-flex>
            <v-flex xs12 sm8 text-xs-center text-sm-left title font-weight-regular style="padding-top: 32px">
              <p class="mb-1">{{ consentScope }}</p>
              <p class="mb-1">{{ consentLicense }} License</p>
              <p class="mb-1">Expires {{ consentExpiration }}</p>
            </v-flex>
          </v-layout>
          <v-btn color="secondary" large @click="redeem" v-if="!loading">
            Redeem
          </v-btn>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="secondary"
          ></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-if="codeError">
      <v-layout justify-center wrap row>
        <v-flex xs10 headline ma-3 pa-5 red--text text-xs-center elevation-1>
          {{ codeError }}
        </v-flex>
      </v-layout>
    </v-container>
    <v-container grid-list-xl fluid ma-3 text-xs-center v-if="collectUsername">
      <v-layout justify-center wrap row>
        <v-flex xs10 headline ma-3>
          Let's get started. Please enter your email address.
        </v-flex>
        <v-flex xs8 elevation-2 white pa-5 style="max-width:550px">
          <v-alert
            :value="error"
            type="error"
            outline
          >
            {{ error }}
          </v-alert>
          <v-text-field outline label="Email Address" v-model="email" @keyup.enter="checkUsername">
          </v-text-field>
          <v-btn color="secondary" large @click="checkUsername">
            Next
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container ma-3 fluid v-if="collectLogin">
      <p class="text-xs-center headline ma-3">An account was found for your email address. Please log in to continue.</p>
      <form v-on:keyup.enter="login">
        <v-container pa-5 style="max-width: 650px" elevation-1>
          <v-layout row wrap>
            <v-flex xs12 mb-4 v-if="loginError">
              <v-alert
                :value="loginError"
                type="error"
                outline
              >
                {{ loginError }}
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                color="secondary"
                label="Username"
                v-model="email"
                :rules="[rules.required]"
                prepend-inner-icon="person"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                color="secondary"
                label="Password"
                type="password"
                v-model="password"
                :rules="[rules.required]"
                prepend-inner-icon="lock"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 mt-1 text-sm-left text-xs-center>
              <router-link :to="{ path: '/reset-password' }">
                <div style="height:36px; line-height:36px; color: #3296f3">Forgot Password?</div>
              </router-link>
            </v-flex>
            <v-flex xs12 sm6 mt-1 text-xs-center text-sm-right>
              <v-btn class="ma-0"
                v-if="!loading"
                color="secondary"
                dark
                v-on:click="login">Login</v-btn>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-container>
    <v-container ma-3 fluid v-if="collectRegistration">
      <p class="text-xs-center headline ma-3">Create your Brainingcamp account.</p>
      <form v-on:keyup.enter="register">
        <v-container grid-list-md pa-5 style="max-width: 650px" elevation-1>
          <v-layout row wrap>
            <v-flex xs12 mb-4 v-if="registerError">
              <v-alert
                :value="registerError"
                type="error"
                outline
              >
                {{ registerError }}
              </v-alert>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outline
                color="secondary"
                label="Email Address"
                v-model="registrationInfo.username"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                outline
                color="secondary"
                label="Password"
                type="password"
                v-model="registrationInfo.password"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                color="secondary"
                label="First Name"
                v-model="registrationInfo.firstname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                color="secondary"
                label="Last Name"
                v-model="registrationInfo.lastname"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outline
                color="secondary"
                label="School"
                v-model="registrationInfo.school"
                :rules="[rules.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-combobox
                outline
                color="secondary"
                label="Role"
                v-model="registrationInfo.role"
                :items="['Teacher',
                  'Principal',
                  'Math Coordinator',
                  'Technology Coordinator',
                  'Other']"
                :rules="[rules.required]"
              ></v-combobox>
            </v-flex>
            <v-flex xs6>
              <v-combobox
                outline
                color="secondary"
                label="Country"
                v-model="registrationInfo.country"
                :items="['Australia','Canada','Denmark','Finland','France','Germany','Mexico','New Zealand','Norway','Sweden','Switzerland','United Kingdom','United States','Other']"
                :rules="[rules.required]"
              ></v-combobox>
            </v-flex>
            <v-flex xs6 v-if="registrationInfo.country === 'United States'">
              <v-text-field
                outline
                color="secondary"
                label="Zip Code"
                v-model="registrationInfo.zipcode"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 mt-1 text-xs-center>
              <v-btn class="ma-0"
                v-if="!loading"
                color="secondary"
                dark
                v-on:click="register">Register</v-btn>
              <v-progress-circular
                v-if="loading"
                indeterminate
                color="secondary"
              ></v-progress-circular>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-container>
  </div>
</template>

<script>
import {debounce, find} from 'lodash'
import manips from '@/data/manips.js'
import RedeemService from '@/services/RedeemService'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  components: {
  },
  data: function () {
    return {
      code: null,
      codeError: null,
      consentIcon: '/virtual-manipulatives-bundle-icon.png',
      consentScope: null,
      consentLicense: null,
      consentExpiration: null,
      redeemError: null,
      collectConsent: false,
      collectUsername: false,
      collectRegistration: false,
      collectLogin: false,
      error: null,
      email: null,
      loginError: null,
      loading: null,
      password: null,
      registerError: null,
      registrationInfo: {
        username: null,
        password: null,
        firstname: null,
        lastname: null,
        school: null,
        country: 'United States',
        zipcode: null,
        role: 'Teacher'
      },
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  mounted: async function () {
    const code = this.$route.params.code

    if (!code) {
      this.codeError = 'This code is not valid.'
      return
    }

    if (this.$store.getters.loggedIn && this.$store.getters.user.type === 'classroom') {
      this.$router.push({
        path: '/logout'
      })
    }

    try {
      const result = await RedeemService.get(code)

      this.code = result.data

      if (result.data.redeemed) {
        this.codeError = 'This code has already been redeemed.'
        return
      }

      if (result.data.type !== 'redemption') {
        this.codeError = 'This code is not valid.'
        return
      }
    } catch (err) {
      this.codeError = err.response.data.error
      return
    }

    if (this.$store.getters.loggedIn) {
      this.prepareConsent()
    } else {
      this.collectUsername = true
    }
  },
  methods: {
    async checkUsername () {
      try {
        const result = await AuthenticationService.checkUsernameAvailability({
          username: this.email
        })

        if (result.data.available) {
          this.collectRegistration = true
          this.collectUsername = false
          this.registrationInfo.username = this.email
        } else {
          this.collectLogin = true
          this.collectUsername = false
        }
      } catch (err) {
        this.error = 'Could not verify email address.'
      }
    },
    login: async function () {
      this.loginError = null;
      this.loading = true;
      
      try {
        const response = await AuthenticationService.login({
          username: this.email,
          password: this.password
        })
        
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)

        this.collectLogin = false
        this.prepareConsent()

      } catch(err) {
        console.log(err.response.data.error);
      }
      
      this.loading = false;
    },
    register: async function () {
      this.registerError = null;
      this.loading = true;
      const code = this.$route.params.code

      const payload = {
        username: this.registrationInfo.username,
        password: this.registrationInfo.password,
        firstname: this.registrationInfo.firstname,
        lastname: this.registrationInfo.lastname,
        school: this.registrationInfo.school,
        country: this.registrationInfo.country,
        role: this.registrationInfo.role
      }

      if (this.registrationInfo.zipcode !== '') {
        payload.zipcode = this.registrationInfo.zipcode
      } else {
        payload.zipcode = null
      }

      try {
        const response = await RedeemService.registerWithRedemptionCode(code, payload);
        //
        if (response.data.success) {
          const loginResponse = await AuthenticationService.login({
            username: this.registrationInfo.username,
            password: this.registrationInfo.password
          })
          
          this.$store.dispatch('setToken', loginResponse.data.token)
          this.$store.dispatch('setUser', loginResponse.data.user)

          this.collectRegistration = false
          this.prepareConsent()
        }
      } catch(err) {
        console.log(err)
        this.registerError = err.response.data.error;
      }
      

      this.loading = false;
    },
    prepareConsent: async function () {
      const config = find(manips, {'id': this.code.license.scope});
      
      if (this.code.license.scope === '*') {
        this.consentScope = 'All Manipulatives'
        this.consentIcon = '/virtual-manipulatives-bundle-icon.png'
      } else {
        this.consentScope = config.displayName
        this.consentIcon = '/' + config.iconFileName
      }

      switch (this.code.license.type.toLowerCase()) {
        case 'teacher':
          this.consentLicense = 'Teacher'
          break
        case 'class':
          this.consentLicense = 'Class'
          break
        case 'school':
          this.consentLicense = 'School'
          break
      }

      const date = new Date(new Date().getTime() + this.code.license.duration * 24 * 60 * 60 * 1000)
      this.consentExpiration = date.toLocaleDateString('en-us', { year: 'numeric', month: 'long', day: 'numeric' })

      this.collectConsent = true
    },
    redeem: async function () {
      this.loading = true
      const code = this.$route.params.code

      try {
        const result = await RedeemService.redeemRedemptionCode(code)

        if (result.data.success) {
          if (result.data.token) {
            //refresh token
            this.$store.dispatch('setToken', result.data.token)
            this.$store.dispatch('setUser', result.data.user)
          }

          this.$router.push({
            name: 'root'
          })
        }
      } catch (err) {
        this.redeemError = err.response.data.error;
      }

      this.loading = false
    }
  }
}
</script>

<style scoped>

</style>
